export default __webpack_public_path__ + "static/media/prenatalLandingPageHowItWorksStep1.0fe3bc01.png";